import { http } from "../http-common";

const CustomerService = {
  confirmIdentity: (id: string | number) => {
    return http.post<any>(`/customers/${id}/identity-confirm`);
  },
};

export default CustomerService;

